import React, { useEffect } from "react";
import { useState } from "react";
import OnlyHeader from "components/Layout/OnlyHeader";
import { Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import DeleteCatalogModal from "components/Modals/DeleteCatalogModal";
import AddAdditionalChargesModal from "components/Modals/AddAditionalChargesModal";
import EditAdditionalChargesModal from "components/Modals/EditAdditionalChargesModal";
import AdditionalChargesTable from "components/Settings/AdditionalCharges/AdditionalChargesTable";
import { fetchAdditionalCharges } from "store/actions/settingAction";

const AdditionalCharges = () => {
  const { user, uid } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { chargesDeleteLoading, additionalCharges } = useSelector(
    (state) => state.setting
  );
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editData, setEditData] = useState("");
  const [index, setIndex] = useState("");

  const addToggle = () => {
    setAddModal(!addModal);
  };
  const editToggle = () => {
    setEditModal(!editModal);
  };
  const deleteToggle = (item, idx) => {
    setEditData(item);
    setIndex(idx);
    setDeleteModal(!deleteModal);
  };

  useEffect(() => {
    if (user?.id) {
      dispatch(fetchAdditionalCharges(user?.id));
    }
  }, [dispatch, user?.id]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <AdditionalChargesTable
          data={additionalCharges}
          addToggle={addToggle}
          editToggle={editToggle}
          deleteToggle={deleteToggle}
          setEditData={setEditData}
          setIndex={setIndex}
          user={user}
        />
      </Container>
      <AddAdditionalChargesModal addModal={addModal} addToggle={addToggle} />

      <EditAdditionalChargesModal
        editModal={editModal}
        editToggle={editToggle}
        editData={editData}
        index={index}
      />
      <DeleteCatalogModal
        deleteModal={deleteModal}
        deleteToggle={deleteToggle}
        editData={editData}
        deleteLoading={chargesDeleteLoading}
        id={uid}
        title={"Charge"}
      />
    </>
  );
};

export default AdditionalCharges;
